<template>
  <div class="container">
    <pages-wrapper>
      <div class="image-wrapper">
        <div class="image" ref="photoWrapper">
          <img class="image-template" :src="templateSrc">
          <img class="image-inner" :src="imageUrl">
        </div>
        <van-row>
          <van-col span="18">
            <div class="ranking-like">
              <span>
                <strong>用户：</strong>
                {{ photoInfo.clientCode }}
              </span>
            </div>
            <div class="ranking-like">
              <span>
                <strong>点赞数：</strong>
                {{ photoInfo.supportCount }}
              </span>
              <img src="../../../assets/images/extra-style/like.png">
            </div>
          </van-col>
          <slot></slot>
        </van-row>
      </div>
    </pages-wrapper>
  </div>
</template>

<script>
import PagesWrapper from './pages-wrapper'
import extraStyleApi from '@/api/extra-style'
import { commonUtils } from '../../../utils/common'
import wxApi from '@/api/wx'
export default {
  name: 'PhotoPreview',
  components: {
    PagesWrapper
  },
  data () {
    return {
      photoInfo: {},
      templateSrc: '',
      imageUrl: '',
      clientId: ''
    }
  },
  created () {
    this.queryExtraStylePhotoDetail()
    this.initWxJsSdk()
  },
  methods: {
    queryExtraStylePhotoDetail () {
      const params = {
        photoId: this.$route.query.photoId || ''
      }
      extraStyleApi.queryExtraStylePhotoDetail(params).then((response) => {
        if (response.data.resultCode === '0') {
          this.photoInfo = response.data.resultData.photoInfo || {}
          this.clientId = response.data.resultData.photoInfo.clientId
          this.$emit('checkedUser')
          this.getTemplateSrc()
          this.getImageUrl()
        }
      })
    },
    getCurrentUrl () {
      let curUrl = document.URL
      if (navigator.userAgent.toLowerCase().match(/iphone|ipad/i)) {
        curUrl = global.entryUrl
      } else if (curUrl && curUrl.indexOf('#') >= 0) {
        curUrl = curUrl.substring(0, curUrl.indexOf('#'))
      }
      // if (curUrl && curUrl.indexOf('#') >= 0) {
      //   curUrl = curUrl.substring(0, curUrl.indexOf('#'))
      // }
      return curUrl
    },
    initWxJsSdk () {
      // this.$toast.loading({ mask: true, message: '加载中...' })
      // const url = document.location.origin + '/v2/extra-style/photo-support?photoId=' + this.$route.query.photoId
      // console.log(url)
      // // 分享好友
      // const appMessageShare = {
      //   title: '易加范活动', // 分享标题
      //   desc: '易加范活动，集赞拿好礼火热进行中', // 分享描述
      //   link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //   imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-style.jpg', // 分享图标
      //   type: 'link', // 分享类型,music、video或link，不填默认为link
      //   dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('appMessageShare success' + url)
      //   },
      //   fail: function () {
      //     console.log('appMessageShare fail')
      //   }
      // }
      // // 分享朋友圈
      // const timelineShare = {
      //   title: '易加范活动', // 分享标题
      //   link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //   imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-style.jpg', // 分享图标
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('timelineShare success' + url)
      //   },
      //   fail: function () {
      //     console.log('appMessageShare fail' + url)
      //   }
      // }
      // commonUtils.configWxJsSdk(appMessageShare, timelineShare).then(() => {
      //   console.log('initWxJsSdk success')
      //   this.$toast.clear()
      // }).catch(error => {
      //   this.$emit('error', { errorMsg: error })
      // })

      const curUrl = this.getCurrentUrl()
      const url = document.location.origin + '/v2/extra-style/photo-support?photoId=' + this.$route.query.photoId
      console.log('curUrl', curUrl)
      return new Promise((resolve, reject) => {
        wxApi.getJsConfig(curUrl).then(response => {
          if (response.data.resultCode === '0') {
            const wxConfig = response.data.resultData.jsapiConfig
            this.$wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: wxConfig.appId, // 必填，公众号的唯一标识
              timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
              nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
              signature: wxConfig.signature, // 必填，签名，见附录1
              jsApiList: [
                // 'updateAppMessageShareData',
                // 'updateTimelineShareData',
                'onMenuShareAppMessage',
                'onMenuShareTimeline'
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
            this.$wx.ready(() => {
              console.log('wx ready')
              this.$wx.onMenuShareAppMessage({
                title: '易加范活动', // 分享标题
                desc: '易加范活动，集赞拿好礼火热进行中', // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-style.jpg', // 分享图标
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                  // 用户点击了分享后执行的回调函数
                  console.log('appMessageShare success' + url)
                },
                fail: function () {
                  console.log('appMessageShare fail')
                }
              })
              this.$wx.onMenuShareTimeline({
                title: '易加范活动', // 分享标题
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-style.jpg', // 分享图标
                success: function () {
                  // 用户点击了分享后执行的回调函数
                  console.log('timelineShare success' + url)
                },
                fail: function () {
                  console.log('appMessageShare fail' + url)
                }
              })
              resolve()
            })
            this.$wx.error((res) => {
              if (res.errMsg.indexOf('invalid signature') !== -1 && location.href.indexOf('refresh=1') === -1) {
                location = location.href + '&refresh=1'
              }
              reject(new Error('初始化微信配置失败'))
            })
          } else {
            reject(new Error('获取微信配置失败'))
          }
        }).catch(() => {
          reject(new Error('网络异常'))
        })
      })
    },
    getTemplateSrc () {
      this.templateSrc = require('../../../assets/images/extra-style/' + this.photoInfo.templateCode + '.png')
    },
    getImageUrl () {
      this.imageUrl = commonUtils.getImageUrl(this.photoInfo.photoUri, this.photoInfo.photoUri)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  img {
    width: 100%;
  }
  .image-wrapper {
    padding: 10px 0 10px 0;
    width: 90%;
    margin: auto;
    text-align: center;
    font-size: 16px;
    color: #999;
    .image {
      position: relative;
      .image-template {
        z-index: 2;
        position: relative;
      }
      .image-inner {
        position: absolute;
        margin: auto;
        top: 15%;
        left: 0;
        right: 0;
        z-index: 2;
        width: 72%;
        height: 61%;
        text-align: center;
      }
    }
    .ranking-like {
      padding-top: 10px;
      line-height: 30px;
      text-align: left;
      span {
        display: inline-block;
        padding-right: 10px;
        word-break: break-all;
      }
    }
    .ranking-like img{
      width: 20px;
      padding-right: 10px;
      vertical-align: sub;
    }
    .ranking-share {
      width: 50%;
      text-align: right;
    }
  }
}
</style>
